import { ReadProcessed } from 'components/hmilib/api';
import { IDataHistory } from 'components/hmilib/hmiclientsdata';
import React from 'react';
import * as hmiclientsdata from '../../../../../hmilib/hmiclientsdata';
import { IRefs } from '../Trends/components/Graph/Graph';
import TuningGraph from './components/Graph.tsx/TuningGraph';
import './index.css';

export interface IPens {
    id: number;
    selected?: boolean;
    enable: boolean;
    name: string;
    curvalue?: string;
    desc?: string;
    eudesc?: string;
    min?: any;
    max?: any;
    color: string;
    typeLine: string | 'line' | 'linePoint' | 'point' | 'step' | 'areadiscrete' | 'radar';
    typeScale: string | 'auto' | 'system' | 'custom';
    yAxisIndex: number | undefined;
    markArea?: any[];
}

export interface IConfig {
    theme: string;
    tagConfig?: IPens[];
    idTrend: string;
    settings: ISettingsGraph;
}

interface ISettingsGraph {
    chart: IChart;
}

interface IChart {
    topmenu: boolean;
    bottommenu: boolean;
    tagonly: boolean;
    hasHistory: boolean;
    TypeTrend: number;
    hasLegend?: boolean;
    xAxis?: IAxisSetting | IAxisSetting[] | undefined;
    yAxis?: IAxisSetting | IAxisSetting[] | undefined;
    Title: string;
    radar?: any;
}

interface ITrendParamDetail {
    config?: IConfig;
}

interface ITrendParamOptions {
    series?: { [id: string]: any[] };
    settings?: ISettingsGraph;
}

interface ITrendParam {
    detail?: ITrendParamDetail;
    options?: ITrendParamOptions;
}

export interface IAxisSetting {
    type: string;
    min?: string;
    max?: string;
    delta?: string;
    name?: string;
}

interface iTuning {
    config?: string;
    id: string | undefined;
    parentID: string;
}

function TuningIndex(props: iTuning) {
    const [xStart, setXStart] = React.useState<string | undefined>(undefined);
    const [xEnd, setXEnd] = React.useState<string | undefined>(undefined);
    const [load, setLoad] = React.useState(false);
    const [paramupdateArchiveItems, setparamupdateArchiveItems] = React.useState<string[]>([]);

    const [hasHistory, sethasHistory] = React.useState<boolean>(false);

    const [newListItems, setnewListItems] = React.useState<string[]>([]);

    const [archive, setArchive] = React.useState<{ [id: string]: [] }>({});
    const [archiveTrend, setArchiveTrend] = React.useState(false);
    const [HmiHistorySettings, setHmiHistorySettings] = React.useState<IPens[] | undefined>(undefined);
    const [idTrend, setidTrend] = React.useState<string | undefined>(undefined);

    const [actionOn, setActionOn] = React.useState<Record<string, Function[]>>({});

    const UpdateGraphInterval = 1000;

    // const [iUpdateX, setiUpdateX] = React.useState<number>(0);
    const MaxUpdateX = 1;

    const [config, setConfig] = React.useState<IConfig>({
        idTrend: '',
        theme: '',
        settings: {
            chart: {
                bottommenu: true,
                hasHistory: true,
                tagonly: true,
                Title: 'demo',
                topmenu: true,
                TypeTrend: 1,
                hasLegend: true,
                xAxis: {
                    type: 'time',
                    delta: 'MAN'
                }
            }
        }
    });

    // Рефы графика
    const refs: IRefs = {
        chartRef: React.useRef<any>(null),
        scrollRefX: React.useRef<HTMLDivElement>(null),
        scrollRefY: React.useRef<HTMLDivElement>(null)
    };

    const [isIntervalActive, setIsIntervalActive] = React.useState<number | null>(1000);

    const intervalId = React.useRef<NodeJS.Timeout | undefined>();

    const [intervalOnOff, setIntervalOnOff] = React.useState(false);
    let id = React.useRef<NodeJS.Timeout | undefined>();

    React.useEffect(() => {
        const clearExistingInterval = () => {
            if (id.current) {
                clearInterval(id.current);
                id.current = undefined;
            }
        };

        clearExistingInterval();

        if (intervalOnOff) {
            id.current = setInterval(Update, UpdateGraphInterval);
        }
        return () => {
            clearExistingInterval();
        };
    }, [intervalOnOff]);

    function StartStopInterval(check: boolean) {
        setIntervalOnOff(check);
    }

    let echarts_react: any = undefined;
    let coloritem = [
        '#00CCFF',
        '#967474',
        '#00cc00',
        '#ffcc00',
        '#ff00ff',
        '#ff0000',
        '#0000ff',
        '#8400ff',
        '#00ff84',
        '#ff8200',
        '#ff0084',
        '#84ffff',
        '#c6c3c6',
        '#84ff00',
        '#ffff84',
        '#ff82ff',
        '#ff8284',
        '#0082ff',
        '#8482ff',
        '#84ff84',
        '#ff8242',
        '#ff82c6',
        '#008284',
        '#848284',
        '#008200',
        '#848200',
        '#840084',
        '#840000',
        '#000084',
        '#420084',
        '#008242',
        '#844100'
    ];

    React.useEffect(() => {
        let newid: string = props.id ? props.id : self.crypto.randomUUID();

        setidTrend(newid);

        return () => {
            window.Trends.RemoveTrend(newid);
        };
    }, [props.id]);

    React.useEffect(() => {
        let configloc = config;

        if (props.config) {
            configloc = JSON.parse(props.config);

            let newconfig = Object_assign(config, configloc);

            SetConfigNew(newconfig);
        }

        let hasHistorytemp = configloc.settings.chart.hasHistory;

        let items = [];

        if (configloc.tagConfig && configloc.tagConfig?.length != 0) {
            for (let pen = 0; pen < configloc.tagConfig.length; pen++) {
                coloritem[pen] = configloc.tagConfig[pen].color;
                items.push(configloc.tagConfig[pen].name);
            }

            setnewListItems(items);
        } else if (configloc.idTrend != '$ID' && configloc.idTrend != '') {
            if (!archiveTrend) updateGroup(Number(configloc.idTrend), '', hasHistorytemp);
        }

        UpdateArchiveItems(items);

        return () => {
            window.parent.UnSubItems(Object.keys(archive));
        };
    }, []);

    const myRef = React.createRef<HTMLDivElement>();

    React.useEffect(() => {
        if (idTrend) {
            let id = idTrend;

            let trend = window.Trends.IntTrend(id);

            let containerId: any = myRef?.current?.parentNode;
            if (containerId) {
                containerId.getTrendInit = () => {
                    return trend;
                };
            }

            if (trend) {
                trend.setParam = function (data: any) {
                    updateParam(data);
                };

                trend.addPen = function (pen: IPens, data: any[]) {
                    let newconfig: IConfig = JSON.parse(JSON.stringify(config));
                    if (newconfig.tagConfig == null) {
                        newconfig.tagConfig = [];
                    }
                    newconfig.tagConfig?.push(pen);

                    let param: ITrendParam = {
                        detail: { config: newconfig },
                        options: {
                            series: {}
                        }
                    };

                    if (param.options?.series) {
                        for (const [key, value] of Object.entries(archive)) {
                            let tempvaluex: any[] = [];
                            let tempvaluey: any[] = [];
                            value.map(function (item) {
                                tempvaluex.push(item[0]);
                                tempvaluey.push(item[1]);
                            });

                            param.options.series[key] = [tempvaluex, tempvaluey];
                        }

                        param.options.series[pen.name] = data;
                    }
                    updateParam(param);
                    return newconfig.tagConfig.length - 1;
                };

                trend.clearTrend = function () {
                    let newconfig: IConfig = JSON.parse(JSON.stringify(config));

                    newconfig.tagConfig = [];

                    let param: ITrendParam = {
                        detail: {
                            config: newconfig
                        },
                        options: {
                            series: {}
                        }
                    };
                    updateParam(param);
                };

                trend.delPen = function (idPen: number) {
                    let res = -1;
                    let newconfig: IConfig = JSON.parse(JSON.stringify(config));
                    let newarchive = archive;

                    if (newconfig.tagConfig) {
                        if (newconfig.tagConfig?.length > idPen) {
                            let nameDel = newconfig.tagConfig[idPen].name;
                            delete newarchive[nameDel];

                            newconfig.tagConfig?.splice(idPen, 1);

                            let param: ITrendParam = {
                                detail: { config: newconfig },
                                options: {
                                    series: {}
                                }
                            };

                            if (param.options?.series) {
                                for (const [key, value] of Object.entries(archive)) {
                                    if (key != nameDel) {
                                        let tempvaluex: any[] = [];
                                        let tempvaluey: any[] = [];
                                        value.map(function (item) {
                                            tempvaluex.push(item[0]);
                                            tempvaluey.push(item[1]);
                                        });

                                        param.options.series[key] = [tempvaluex, tempvaluey];
                                    }
                                }
                            }

                            updateParam(param);
                            res = 1;
                        }
                    }

                    return res;
                };

                trend.showLoading = function () {
                    setLoad(true);
                };

                trend.hideLoading = function () {
                    setLoad(false);
                };

                trend.dispatchAction = function (payload: any) {
                    if (payload) {
                        payload.type = payload.type?.toLowerCase();
                        if (actionOn[payload.type]) {
                            for (let paramind = actionOn[payload.type].length; paramind--; ) {
                                actionOn[payload.type][paramind].call(trend, payload.data);
                            }
                        }

                        let handletxt = containerId.getAttribute('on' + payload.type);
                        if (handletxt) {
                            ((data: any) => {
                                eval(handletxt);
                            }).call(trend, payload.data);
                        }
                    }
                };

                trend.on = function (eventName: string, handler: Function) {
                    let actionOnTemp = { ...actionOn };
                    eventName = eventName.toLowerCase();

                    if (actionOnTemp[eventName] == null) {
                        actionOnTemp[eventName] = [];
                    }

                    actionOnTemp[eventName].push(handler);
                    setActionOn(actionOnTemp);
                };

                trend.off = function (eventName: string, handler: Function) {
                    let actionOnTemp = { ...actionOn };
                    eventName = eventName.toLowerCase();
                    if (actionOnTemp[eventName]) {
                        for (let paramind = actionOn[eventName].length; paramind--; ) {
                            if (actionOn[eventName][paramind] == handler) {
                                actionOnTemp[eventName].splice(paramind, 1);
                                paramind++;
                            }
                        }

                        setActionOn(actionOnTemp);
                    }
                };
            }
        }
    });

    const updateParam = (data: ITrendParam) => {
        if (data) {
            let configloc = data?.detail?.config;

            if (configloc) {
                let newconfig: IConfig = Object_assign(config, configloc);

                SetConfigNew(newconfig);

                setArchiveTrend(true);

                let s: string[] = [];

                if (newconfig.tagConfig != undefined) {
                    for (let i = 0; i < newconfig.tagConfig.length; i++) {
                        if (newconfig.tagConfig[i].name != '') s.push(newconfig.tagConfig[i].name);
                    }

                    setparamupdateArchiveItems(s);
                }
            }

            if (data.options) {
                if (data.options.settings?.chart) {
                    if (data.options.settings.chart.hasHistory != undefined) {
                        sethasHistory(data.options.settings.chart.hasHistory);
                    }

                    // if (data.options.settings?.chart?.bottommenu != undefined)
                    //     setvisibleBottomMenu(data.options.settings.chart.bottommenu);
                    // if (data.options.settings?.chart?.topmenu != undefined)
                    //     setvisibleTopMenu(data.options.settings.chart.topmenu);
                }

                if (data.options.series) {
                    if (HmiHistorySettings) {
                        let datas: any[] = [];

                        for (let item of Object.keys(data.options.series)) {
                            if (data.options.series[item]) {
                                let newdata: IDataHistory = {
                                    ID: item,
                                    Q: data.options.series[item][2],
                                    T: data.options.series[item][0],
                                    V: data.options.series[item][1]
                                };
                                datas.push(newdata);
                            }
                        }

                        setArchiveTrend(true);

                        updateDataParam(datas);
                    }
                }
            }
        }
    };

    const UpdateArchive = (newseries: any[]) => {
        if (HmiHistorySettings) {
            let cloneHmiHistory = HmiHistorySettings.slice();

            let temparchive: any = {};

            temparchive = JSON.parse(JSON.stringify(archive));

            for (let paramind = HmiHistorySettings.length; paramind--; ) {
                if (newseries[paramind]) {
                    for (let i in newseries[paramind]) {
                        let val = Number(newseries[paramind][i][1]);
                        let t = newseries[paramind][i][0];

                        let len = temparchive[cloneHmiHistory[paramind].name].length;
                        if (len > 2) {
                            if (xStart) {
                                if (temparchive[cloneHmiHistory[paramind].name][1][0] < xStart) {
                                    temparchive[cloneHmiHistory[paramind].name].shift();
                                    len--;
                                }
                            }

                            let lastval = temparchive[cloneHmiHistory[paramind].name][len - 1];

                            if (temparchive[cloneHmiHistory[paramind].name][len - 2][1] == lastval[1]) {
                                temparchive[cloneHmiHistory[paramind].name][len - 2][0] = lastval[0];
                                temparchive[cloneHmiHistory[paramind].name].pop();
                                len--;
                            }
                        }

                        if (len > 0) {
                            if (t > temparchive[cloneHmiHistory[paramind].name][len - 1][0]) {
                                temparchive[cloneHmiHistory[paramind].name].push([t.toISOString(), val]);
                                if (cloneHmiHistory[paramind].typeScale === 'auto') {
                                    if (cloneHmiHistory[paramind].max < val) {
                                        let scaleminmax = Math.abs(Number(val) - Number(cloneHmiHistory[paramind].min));
                                        cloneHmiHistory[paramind].max = Number(Number(val) + scaleminmax * 0.1).toFixed(
                                            3
                                        );
                                    } else if (cloneHmiHistory[paramind].min > val) {
                                        let scaleminmax = Math.abs(Number(cloneHmiHistory[paramind].max) - Number(val));
                                        cloneHmiHistory[paramind].min = Number(Number(val) - scaleminmax * 0.1).toFixed(
                                            3
                                        );
                                    }
                                }
                            } else {
                                temparchive[cloneHmiHistory[paramind].name].push([
                                    window.SystemDate().toISOString(),
                                    val
                                ]);
                            }
                        } else {
                            temparchive[cloneHmiHistory[paramind].name].push([t.toISOString(), val]);
                            let scaleminmax = Math.abs(Number(val));
                            cloneHmiHistory[paramind].max = Number(Number(val) + scaleminmax * 0.1).toFixed(3);
                            cloneHmiHistory[paramind].min = Number(Number(val) - scaleminmax * 0.1).toFixed(3);
                        }

                        cloneHmiHistory[paramind].curvalue = val.toString();
                    }
                }
            }

            setArchive(temparchive);
            setHmiHistorySettings(cloneHmiHistory);
        }
    };

    const [newSeriesPoints, setNewSeriesPoints] = React.useState<any[]>([]);

    let iUpdateX = 0;

    async function Update() {
        try {
            if (HmiHistorySettings && !archiveTrend) {
                let newseries: any = {};
                for (let paramind = HmiHistorySettings.length; paramind--; ) {
                    if (HmiHistorySettings[paramind].name != '') {
                        let parnew = window.parent.GetParam(HmiHistorySettings[paramind].name);
                        let val = parnew.V;
                        let t = window.SystemDate();

                        newseries[paramind] = [[t, val]];
                    }
                }

                await UpdateArchive(newseries);

                setNewSeriesPoints(newseries);

                if (iUpdateX == 0) {
                    let newconfig = { ...config };

                    if (newconfig.settings?.chart?.xAxis as IAxisSetting) {
                        (newconfig.settings.chart.xAxis as IAxisSetting).max = window.ConvertDateISOtoNs(
                            new Date(window.SystemDate().setMilliseconds(MaxUpdateX * UpdateGraphInterval))
                        );
                    }
                    SetConfigNew(newconfig);
                }

                if (iUpdateX >= MaxUpdateX) {
                    // setiUpdateX(0);
                    iUpdateX = 0;
                } else {
                    // setiUpdateX(iUpdateX + 1);
                    iUpdateX++;
                }
            }
            // setTimeout(Update, UpdateGraphInterval);
        } catch (ex) {
            console.dir(ex);
        }
    }

    const isObject = function (item: any) {
        return item && typeof item === 'object' && !Array.isArray(item);
    };

    const Object_assign = function (target: any, ...sources: any): any {
        if (!sources.length) return target;
        const source = sources.shift();

        if ((isObject(target) || null) && isObject(source)) {
            for (const key in source) {
                if (isObject(source[key])) {
                    if (!target[key]) Object.assign(target, { [key]: {} });
                    if (!isObject(target[key])) {
                        target[key] = {};
                    }
                    Object_assign(target[key], source[key]);
                } else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }
        return Object_assign(target, ...sources);
    };

    const SetConfigNew = function (confignew: IConfig) {
        if (confignew.settings.chart.xAxis) {
            if (
                (confignew.settings.chart.xAxis as IAxisSetting)?.delta?.includes('h') &&
                (confignew.settings.chart.xAxis as IAxisSetting)?.type == 'time'
            ) {
                if ((confignew.settings.chart.xAxis as IAxisSetting)?.max == null) {
                    let xDelta =
                        Number((confignew.settings.chart.xAxis as IAxisSetting)?.delta?.replaceAll('h', '')) * 3600000;
                    let min = window.ConvertDateISOtoNs(new Date(window.SystemDate().setMilliseconds(xDelta)));
                    let max = window.ConvertDateISOtoNs(new Date(window.SystemDate().setMilliseconds(5000)));

                    (confignew.settings.chart.xAxis as IAxisSetting).min = min;
                    (confignew.settings.chart.xAxis as IAxisSetting).max = max;
                }
            }
        }

        if (confignew.tagConfig) {
            for (let i = 0; i < confignew.tagConfig?.length; i++) {
                confignew.tagConfig[i].enable =
                    confignew.tagConfig[i].enable == null || confignew.tagConfig[i].enable == true ? true : false;
            }
        }

        let max = null;
        let min = null;
        if (
            (confignew.settings.chart.xAxis as IAxisSetting)?.min != '' &&
            (confignew.settings.chart.xAxis as IAxisSetting)?.min != null
        ) {
            min = (confignew.settings.chart.xAxis as IAxisSetting).min;
            if ((confignew.settings.chart.xAxis as IAxisSetting).type == 'time') {
                min = GetDate(min);
                (confignew.settings.chart.xAxis as IAxisSetting).min = min;
            }

            setXStart(min);
        }

        if (
            confignew.settings.chart.xAxis &&
            (confignew.settings.chart.xAxis as IAxisSetting)?.max != '' &&
            (confignew.settings.chart.xAxis as IAxisSetting)?.max != null
        ) {
            max = (confignew.settings.chart.xAxis as IAxisSetting).max;
            if ((confignew.settings.chart.xAxis as IAxisSetting).type == 'time') {
                max = GetDate(max);
                (confignew.settings.chart.xAxis as IAxisSetting).max = max;
            }

            setXEnd(max);
        } else if (min == null && max == null) {
            console.log('not set xAxis');
        }

        setConfig(confignew);
    };

    const updateDataParam = (
        data: IDataHistory[],
        group: number | undefined = undefined,
        Select: string | undefined = undefined
    ) => {
        if (Select == '' || Select == null || '$SELECT' == Select) {
            Select = '';
        }
        Select = Select.toUpperCase();

        window.parent.SubItems(data.map((ele) => ele.ID));

        let newdataobj: any = {};

        if (data) {
            let temparchive = {};
            let tempHmiHistorySettings: IPens[] = new Array(coloritem.length);
            let tempColor: any[] = [];
            if (HmiHistorySettings !== undefined) {
                HmiHistorySettings.forEach((item) => {
                    tempColor.push(item.color);
                });
            }

            let HistorySettings: any = undefined;
            if (group != undefined && group != 0) {
                HistorySettings = hmiclientsdata.GetHistorySettings()[group];
            }

            let activeitem = false;

            let endtimeiso = new Date().toISOString();

            let idlist = 0;

            for (let id2 in data) {
                idlist++;
                let name = data[id2].ID;
                let lastTime = data[id2].T[data[id2].T.length - 1];

                if (!archiveTrend) {
                    if (lastTime < Number(endtimeiso)) {
                        let parnew = window.parent.GetParam(name);
                        if (parnew.V != name) {
                            let val = Number(Number(parnew.V).toFixed(3));
                            data[id2].T.push(window.ConvertDateISOtoNs(window.SystemDate()));
                            data[id2].Q?.push(Number(parnew.Q));
                            data[id2].V.push(val);
                        }
                    }
                }

                let minMax_markArea = getMinMax_markArea(data[id2]);

                let newdata = [];

                for (let ida = data[id2].V.length; ida--; ) {
                    let val = data[id2].V[ida];
                    if ((config.settings.chart?.xAxis as IAxisSetting)?.type != 'time') {
                        newdata.unshift([data[id2].T[ida], val]);
                    } else {
                        newdata.unshift([GetDate(data[id2].T[ida]), val]);
                    }
                }

                let HistSettings = tempHmiHistorySettings.filter((f) => f.name == name)[0];

                if (HistSettings?.selected) {
                    activeitem = true;
                }

                let desc = '';
                let eudesc = '';
                HistSettings = CreateItem(idlist, name, desc, eudesc, undefined, 'auto');
                tempHmiHistorySettings[idlist - 1] = HistSettings;
                HistSettings.max = minMax_markArea.max;
                HistSettings.min = minMax_markArea.min;
                HistSettings.markArea = minMax_markArea.markArea;

                if (HistorySettings != null) {
                    if (HistorySettings[idlist - 1].min != null) {
                        HistSettings.min = HistorySettings[idlist - 1].min;
                    }
                    if (HistorySettings[idlist - 1].max != null) {
                        HistSettings.max = HistorySettings[idlist - 1].max;
                    }
                    let enable = HistorySettings[idlist - 1].enable;
                    let step = HistorySettings[idlist - 1].step;
                    HistSettings.enable = enable;
                }

                newdataobj[name] = newdata;
            }

            for (let i = 0; i < tempHmiHistorySettings.length; i++) {
                if (!tempHmiHistorySettings[i]) {
                    let active = false;
                    tempHmiHistorySettings[i] = {
                        id: i + 1,
                        color: coloritem[i],
                        curvalue: '',
                        yAxisIndex: undefined,
                        desc: '',
                        eudesc: '',
                        min: 0,
                        max: 100,
                        enable: false,
                        name: '',
                        selected: active,
                        typeLine: 'line',
                        typeScale: 'auto'
                    };
                }

                if (
                    (tempHmiHistorySettings[i].name.indexOf(Select) == 0 && Select != '') ||
                    (!activeitem && Select == '') ||
                    (!activeitem && Select == undefined)
                ) {
                    tempHmiHistorySettings[i].selected = true;
                    activeitem = true;
                }
            }

            let temparchivenew = { ...temparchive, ...newdataobj };
            // console.log(temparchivenew);
            setArchive(temparchivenew);
            setHmiHistorySettings(tempHmiHistorySettings);
        }
    };

    let CreateItem = function (
        id: number,
        param: string,
        desc: string,
        eudesc: string,
        typeLine: string | undefined,
        typeScale: string,
        colorItem?: string
    ): IPens {
        let item = param.toUpperCase().substr(0, param.lastIndexOf('.'));

        if (item.indexOf('.VALUE') != -1) {
            item = param.toUpperCase().substr(0, item.lastIndexOf('.'));
        }

        let curvalue = Number(window.parent.GetParam(param).V).toFixed(3);

        let tempDesc = '';
        let tempEudesc = '';

        let minmax = 1;
        if (Number(curvalue) > 1) {
            minmax = Number(curvalue) * 2;
        }

        let min = (Number(window.parent.GetParam(param).V) - minmax).toFixed(3);
        let max = (Number(window.parent.GetParam(param).V) + minmax).toFixed(3);
        let index = id;

        let color = coloritem[index - 1];
        if (colorItem !== undefined) {
            color = colorItem;
        }

        let enable = true;
        let yAxisIndex = undefined;

        if (config.tagConfig) {
            if (typeLine == null) {
                typeLine = config.tagConfig[id - 1]?.typeLine || 'line';
            }

            yAxisIndex =
                config.tagConfig[id - 1]?.yAxisIndex != null ? config.tagConfig[id - 1]?.yAxisIndex : yAxisIndex;

            enable = config.tagConfig[id - 1]?.enable;
            if (config.tagConfig[id - 1]?.color !== undefined) {
                color = config.tagConfig[id - 1]?.color;
            }
            tempDesc = config.tagConfig[id - 1]?.desc || '';
            tempEudesc = config.tagConfig[id - 1].eudesc || '';
        }

        if (tempDesc == '' || tempDesc == null) {
            desc = window.parent.GetParam(item + '.description').V;
            if (desc == '.description' || desc == null || desc == 'null') desc = '';
        } else {
            desc = window.parent.GetParam(tempDesc).V;
        }

        if (tempEudesc !== null) {
            eudesc = window.parent.GetParam(tempEudesc).V;
        }

        if (typeLine == null) {
            typeLine = 'line';
        }
        let tempMarkArea: any = {
            itemStyle: {
                color: 'rgba(255, 173, 177, 0.3)'
            },
            data: []
        };

        let itemalarm: IPens = {
            id: id,
            color: color,
            curvalue: curvalue,
            desc: desc,
            eudesc: eudesc,
            min: min,
            max: max,
            enable: enable,
            name: param,
            selected: false,
            typeLine: typeLine,
            typeScale: typeScale,
            yAxisIndex: yAxisIndex,
            markArea: tempMarkArea
        };
        return itemalarm;
    };

    const UpdateArchiveItems = function (param: string[]) {
        setArchive({});
        ReadHistoryData(param).then((data: any) => {
            if (data) {
                updateDataParam(data);
            }
        });
    };

    const ReadHistoryData = async function (Items: string[]) {
        let endtimeiso = new Date().toISOString();

        const twoHoursAgo = new Date();
        twoHoursAgo.setHours(twoHoursAgo.getHours() - 12);
        let starttimeiso = twoHoursAgo.toISOString();

        let funcName: string[] = [];
        Items.forEach((element) => funcName.push('INTERPOLATIVE'));

        let maxPoint = 7200;
        let countPoint = maxPoint;

        let deltaNs = (new Date(endtimeiso).getTime() - new Date(starttimeiso).getTime()) * 1000000;

        let intervalNs = Math.floor(deltaNs / countPoint);

        return ReadProcessed(Items, funcName, starttimeiso, endtimeiso, intervalNs);
    };

    const updateGroup = (newgroup: number, Select: string, hasHistory = true) => {
        let hist = hmiclientsdata.GetHistorySettings()[newgroup];
        if (hist != null) {
            let Items = [];
            for (let key in hist) {
                if (hist[key].param != '') {
                    Items.push(hist[key].param);
                }
            }

            updateTag(Items, Select, newgroup);
        } else {
            updateDataParam([], newgroup, Select);
        }
    };

    const updateTag = (Items: string[], Select: string, newgroup = -1, hasHistory = true) => {
        if (hasHistory) {
            ReadHistoryData(Items).then((data: any) => {
                if (data) {
                    updateDataParam(data, newgroup, Select);
                }
            });

            //hmiclientbase.ReadRawAsync(Items, starttimeiso, endtimeiso, 0, 1).then((data: any) => { if (data) { ConstrData(data, newgroup, Select) } });
        } else {
            let datas: any = [];
            for (let item in Items) {
                let data: IDataHistory = { ID: item, Q: [], T: [], V: [] };
                datas.push(data);
            }

            updateDataParam(datas, newgroup, Select);
        }
        // console.log('updateTag')
    };

    const getMinMax_markArea = (data: IDataHistory) => {
        let newMin: number | null = null;
        let newMax: number | null = null;

        let tempMarkArea: any = {
            itemStyle: {
                color: 'rgba(255, 173, 177, 0.3)'
            },
            data: []
        };
        let startMarkArea: boolean = false;

        for (let i = data.V.length; i--; ) {
            let val = data.V[i];

            if (data.Q) {
                if (data.Q[i] !== 0) {
                    if (!startMarkArea) {
                        if (data.V.length !== i) {
                            tempMarkArea.data.unshift([{}, { xAxis: GetDate(data.T[i + 1]) }]);
                            startMarkArea = true;
                        }
                    }
                } else {
                    if (startMarkArea) {
                        tempMarkArea.data[0][0].xAxis = GetDate(data.T[i + 1]);
                        startMarkArea = false;
                    }
                }
            }

            if (!Number.isNaN(Number(val))) {
                if (newMin === null || Number.isNaN(newMin)) {
                    newMin = val;
                }
                if (newMax === null || Number.isNaN(newMax)) {
                    newMax = val;
                }
            }
            if (newMin != null && newMax != null) {
                if (val > newMax) {
                    newMax = val;
                } else if (val < newMin) {
                    newMin = val;
                }
            }
        }

        let scaleminmax = Math.abs(Number(newMax?.toFixed(3)) - Number(newMin?.toFixed(3)));
        scaleminmax = Number(scaleminmax.toFixed(3));
        if (scaleminmax === 0) {
            scaleminmax = 1;
        } else if (scaleminmax < 0.2) {
            scaleminmax = 0.2;
        }

        let max = '0';
        if (newMax != null) {
            max = Number(newMax + scaleminmax * 0.05).toFixed(3);
        }
        let min = '0';
        if (newMin != null) {
            min = Number(newMin - scaleminmax * 0.05).toFixed(3);
        }

        return { max: max, min: min, markArea: tempMarkArea };
    };

    const GetDate = (datelong: any) => {
        if (typeof datelong == 'number') {
            return window.ConvertDateNsToISO(datelong);
        } else {
            return new Date(datelong);
        }
    };

    // Tabs buttons
    const handleChartRef = (ref: any) => {
        // ChartRef.current = ref;
    };

    const [showPenAssignment, setShowPenAssignment] = React.useState(false);
    const handlePenAssignment = () => {
        setShowPenAssignment(true);
        console.log('worked');
    };

    const closePenAssignment = () => {
        setShowPenAssignment(false);
    };

    if (HmiHistorySettings) {
        return (
            <>
                {/* <TuningTab/> */}
                <div ref={myRef} className="graph">
                    <TuningGraph
                        refs={refs}
                        data={archive}
                        pens={HmiHistorySettings}
                        echarts_react={echarts_react}
                        config={config}
                        intervalOnOff={intervalOnOff}
                        parentID={props.parentID}
                        newSeriesPoints={newSeriesPoints}
                        onChartRef={handleChartRef}
                        SetInterval={StartStopInterval}
                    />
                </div>
            </>
        );
    } else {
        return <></>;
    }
}

export default TuningIndex;

function useInterval(callback: any, delay: any) {
    const savedCallback: any = React.useRef();

    // Remember the latest callback.
    React.useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    React.useEffect(() => {
        function tick() {
            if (savedCallback) savedCallback.current();
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}
